import { render, staticRenderFns } from "./Postulants.vue?vue&type=template&id=1fdfb546&"
import script from "./Postulants.vue?vue&type=script&lang=js&"
export * from "./Postulants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports